import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Sends a GET request to the backend API using the configured base URL.
   * @param path API path beginning with a slash.
   * @returns Observable of the typed response body.
   */
  get<T>(path: string) {
    return this.http.get<T>(`${this.baseUrl}${path}`);
  }

  /**
   * Sends a POST request to create or trigger backend resources/actions.
   * @param path API path beginning with a slash.
   * @param body Request payload.
   * @returns Observable of the typed response body.
   */
  post<T>(path: string, body: unknown) {
    return this.http.post<T>(`${this.baseUrl}${path}`, body);
  }

  /**
   * Sends a PUT request for full resource updates.
   * @param path API path beginning with a slash.
   * @param body Updated resource payload.
   * @returns Observable of the typed response body.
   */
  put<T>(path: string, body: unknown) {
    return this.http.put<T>(`${this.baseUrl}${path}`, body);
  }

  /**
   * Sends a PATCH request for partial resource updates.
   * @param path API path beginning with a slash.
   * @param body Partial update payload.
   * @returns Observable of the typed response body.
   */
  patch<T>(path: string, body: unknown) {
    return this.http.patch<T>(`${this.baseUrl}${path}`, body);
  }

  /**
   * Sends a DELETE request for removable resources.
   * @param path API path beginning with a slash.
   * @returns Observable of the typed response body.
   */
  delete<T>(path: string) {
    return this.http.delete<T>(`${this.baseUrl}${path}`);
  }
}
